// STAGING LOGIC / STAGE LEFT NAV BAR OLD
// /** @jsxRuntime classic */
// /** @jsx jsx */
// import { jsx } from '@emotion/core';
// import {
//   useState,
//   useEffect,
//   useRef,
//   Fragment,
//   useContext,
//   MouseEvent,
//   TouchEvent,
//   useCallback,
// } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
// import { Tree, Modal, message, ConfigProvider } from 'antd';
// import { useIntl } from 'react-intl';
// import { IconProp } from '@fortawesome/fontawesome-svg-core';
// import { DataNode, DirectoryTreeProps, EventDataNode } from 'antd/lib/tree';
//
// import IconButton from '~components/_common/IconButton/IconButton';
// import navigationItems, {
//   navigationItemsTimeMachine,
// } from '~src/data/navigationItems';
// import { getParentsIds } from '~src/utils/tree';
// import { DbFolder, DbFocusOptions } from '~src/types/db';
// import { TREE_MIN_WIDTH } from '~src/config';
// import { useFolders } from '~src/hooks/api-hooks/useFolders';
// import { useProject } from '~src/hooks/api-hooks/useProject';
//
// import dataContextMenu from '~src/data/dataContextMenu';
// import ShareModal from '~components/popups-modals/ShareModal/ShareModal';
// import { FolderPropertiesModal } from '~components/popups-modals/FolderPropertiesModal/FolderPropertiesModal';
// import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
// import { EditFolderModal } from '~components/popups-modals/EditFolder.modal';
// import { MoveModal } from '~components/popups-modals/Move.modal';
// import { DeleteModal } from '~components/popups-modals/Delete.modal';
// import { NavIcon } from '~components/_common/NavIcon/NavIcon';
// import { downloadFolder } from '~src/utils/download';
// import { appLog } from '~src/utils/log';
// import LargeFilesContext from '~src/contexts/LargeFilesContext';
// import FileVersionsContext from '~src/contexts/FileVersionsContext';
// import { RightsModal } from '~components/popups-modals/RightsModal/RightsModal';
// import { useToggleFavouriteFolder } from '~src/hooks/actions/useToggleFavouriteFolder';
// import { RightClickOverlay } from '~components/atoms/RightClickOverlay/RightClickOverlay';
// import { useItemPermission } from '~src/hooks/useItemPermission';
// import { useProjectId } from '~src/hooks/useProjectId';
//
// import { useIsPath } from '~src/hooks/useIsPath';
//
// import { DB_STATE, MODULES } from '~src/types/enums';
// import ProjectSrc from '~src/assets/nav-icons/project.png';
// import { useModules } from '~src/hooks/api-hooks/useModules';
// import { ItemLogModal } from '~components/popups-modals/ItemLog.modal';
// import _ from 'lodash';
// import { useToggleFocusFolder } from '~src/hooks/actions/useToggleFocusFolder';
// import { focusOptions } from '~components/atoms/RightClickOverlay/data';
// import { useCurrentFolder } from '~src/hooks/useCurrentFolder';
// import { useArchiveSettings } from '~src/hooks/api-hooks/useArchiveSettings';
// import { DownloadingState, useStore } from '~src/store';
// import { useFileViewer } from '~src/contexts/FileToViewContext';
// import {
//   getPrimarySVFRender,
//   getPrimarySVFRenderLocation,
// } from '~src/services/api';
//
// const { DirectoryTree } = Tree;
//
// type StateDataNode = DataNode & {
//   path?: string;
//   children?: StateDataNode[];
//   parentId?: string | null;
//   favourite?: boolean;
//   moduleId?: MODULES;
// };
//
// const LeftSideView: React.FC = () => {
//   // hooks
//   const styles = useStyles(styleFn);
//   const intl = useIntl();
//   const history = useHistory();
//   const location = useLocation();
//   const projectId = useProjectId();
//   const currentFolder = useCurrentFolder();
//
//   const foldersQuery = useFolders({
//     before:
//       window.sessionStorage.getItem('timeMachineDate') !== null
//         ? Number(window.sessionStorage.getItem('timeMachineDate'))
//         : undefined,
//     as_admin:
//       window.sessionStorage.getItem('appState') === 'superUser'
//         ? true
//         : undefined,
//   });
//   const projectQuery = useProject();
//   const isOnArchive = useIsPath('/archive');
//   const isOnModule = useIsPath('/module');
//   const modules = useModules();
//   const archiveSettings = useArchiveSettings();
//
//   const { setLargeFilesContext } = useContext(LargeFilesContext);
//   const { fileVersionsContext } = useContext(FileVersionsContext);
//
//   const { toggleFavouriteFolder } = useToggleFavouriteFolder();
//   const { toggleFocusFolder } = useToggleFocusFolder();
//   const { setPrimaryPreviewFile, setFileToView } = useFileViewer();
//
//   // state for all modals
//   const [shareModal, setShareModal] = useState(false);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [folderEditModal, setFolderEditModal] = useState(false);
//   const [folderMoveModal, setFolderMoveModal] = useState(false);
//   const [folderPropertiesModal, setFolderPropertiesModal] = useState(false);
//   const [folderRightsModal, setFolderRightsModal] = useState(false);
//   const [itemLogModal, setItemLogModal] = useState(false);
//
//   const [rightClickFolder, setRightClickFolder] = useState<DbFolder>();
//   const [
//     rightClickFolderOverlay,
//     setRightClickFolderOverlay,
//   ] = useState<DbFolder>();
//
//   const rightClickFolderParentPermission = useItemPermission({
//     folder: rightClickFolderOverlay,
//   });
//
//   const errorModalRef = useRef<ReturnType<typeof Modal.error>>();
//
//   // states
//   const [treeData, setTreeData] = useState<StateDataNode[]>([
//     {
//       title: '',
//       path: '/',
//       key: 'home',
//       icon: <NavIcon icon={ProjectSrc} />,
//       parentId: null,
//       children: [],
//     },
//   ]);
//
//   const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
//   const [expandedKeys, setExpandedKeys] = useState<string[]>(['home']);
//
//   // effects
//   useEffect(() => {
//     if (modules.data) {
//       setTreeData((prevState) => {
//         const nextState = [...prevState];
//         nextState[0].children = [
//           ...(window.sessionStorage.getItem('appState') === 'timeMachine'
//             ? navigationItemsTimeMachine
//             : navigationItems),
//         ]
//           .filter(
//             (v) =>
//               (v.section !== 'special' ||
//                 (modules.data &&
//                   v?.moduleName &&
//                   modules.data[v.moduleName])) &&
//               v.key !== 'shared-with-me'
//           )
//           .map((navItem) => ({
//             title: intl.formatMessage({ id: navItem.nameTerm }),
//             path: navItem.path,
//             key: navItem.key,
//             moduleId: navItem.id,
//             icon:
//               navItem.section === 'project-data' ? (
//                 <IconButton
//                   icon={navItem.icon as IconProp}
//                   color={navItem.color}
//                   customStyle={styles.icons}
//                   backgroundOff
//                 />
//               ) : (
//                 <NavIcon icon={navItem.customIcon as string} />
//               ),
//             parentId: null,
//           }));
//         return [...nextState];
//       });
//     }
//   }, [modules.data]);
//
//   // recolor primary-svf-viewer whenever:
//   // - archiveSettings loaded OR changed
//   // - treeData base children got built
//   useEffect(() => {
//     setTreeData((prev) => {
//       if (!prev[0] || !prev[0].children || !prev[0].children.length) {
//         return prev;
//       }
//
//       const hasPrimarySVF = !!archiveSettings?.data?.resArchiveSettings
//         ?.primary_svf_render_id; // null -> false
//
//       const next = [...prev];
//       const root = { ...next[0] };
//
//       const newChildren = root?.children?.map((child) => {
//         if (child.key !== 'primary-svf-viewer') return child;
//
//         return {
//           ...child,
//           icon: (
//             <IconButton
//               icon={
//                 navigationItems.find((i) => i.key === 'primary-svf-viewer')
//                   ?.icon as IconProp
//               }
//               color={hasPrimarySVF ? undefined : 'red'}
//               customStyle={[
//                 styles.icons,
//                 hasPrimarySVF ? styles.grayBlue : styles.iconRed,
//               ]}
//               backgroundOff
//             />
//           ),
//         };
//       });
//
//       root.children = newChildren;
//       next[0] = root;
//       return next;
//     });
//   }, [
//     archiveSettings.data,
//     treeData[0]?.children?.length,
//     styles.icons,
//     styles.grayBlue,
//     styles.iconRed,
//   ]);
//
//   useEffect(() => {
//     if (foldersQuery.error) {
//       const modalContent =
//         intl.formatMessage({ id: 'load-folders-error' }) +
//         (foldersQuery.error.code ? ` (${foldersQuery.error.code})` : '');
//
//       if (!errorModalRef.current) {
//         errorModalRef.current = Modal.error({
//           title: intl.formatMessage({ id: 'generic-error' }),
//           content: modalContent,
//           keyboard: false, // disable close on ESC
//           okButtonProps: { loading: foldersQuery.isLoading },
//           okText: intl.formatMessage({ id: 'try-again' }),
//           onOk: () => foldersQuery.refetch({ throwOnError: true }),
//         });
//       } else {
//         errorModalRef.current.update({
//           content: modalContent,
//           okButtonProps: { loading: foldersQuery.isLoading },
//         });
//       }
//     } else if (errorModalRef.current) {
//       errorModalRef.current.destroy();
//       errorModalRef.current = undefined;
//     }
//   }, [foldersQuery, intl]);
//
//   useEffect(() => {
//     if (projectQuery.data) {
//       setTreeData((prevState) => {
//         const nextState = [...prevState];
//         nextState[0].title =
//           projectQuery.data?.name || intl.formatMessage({ id: 'home' });
//         return nextState;
//       });
//     }
//   }, [projectQuery.data]);
//
//   /** set selected item based on location */
//   useEffect(() => {
//     const locationList = location.pathname.split('/').filter(Boolean);
//
//     // if folder location
//     if (locationList.length > 3 && foldersQuery.data) {
//       if (isOnArchive) {
//         const folderId = locationList[3];
//
//         setExpandedKeys((prevExpandedKeys) => {
//           if (prevExpandedKeys.includes(folderId)) {
//             return [...prevExpandedKeys];
//           }
//
//           const parents = getParentsIds(foldersQuery.data || [], folderId);
//
//           return [...prevExpandedKeys, 'archive', ...parents, folderId];
//         });
//
//         setSelectedKeys((prevSelectedKeys) =>
//           prevSelectedKeys[0] === folderId ? [...prevSelectedKeys] : [folderId]
//         );
//
//         return;
//       }
//
//       if (isOnModule) {
//         const moduleId = locationList[3];
//         const matchingItemIndex = (treeData[0]
//           .children as StateDataNode[]).findIndex(
//           (item) => Number(moduleId) === item?.moduleId
//         );
//         const matchingItem = (treeData[0].children as StateDataNode[])[
//           matchingItemIndex
//           ];
//         if (matchingItem) {
//           setExpandedKeys((prevExpandedKeys) =>
//             prevExpandedKeys.includes(matchingItem.key as string)
//               ? [...prevExpandedKeys]
//               : [...prevExpandedKeys, matchingItem.key as string]
//           );
//
//           setSelectedKeys((prevSelectedKeys) =>
//             prevSelectedKeys[0] && prevSelectedKeys[0] === matchingItem.key
//               ? [...prevSelectedKeys]
//               : [matchingItem.key as string]
//           );
//         }
//         return;
//       }
//     }
//
//     if (locationList.length > 1) {
//       // if level 1 location e.g. archive, recent etc.
//       // if no lv1 location, match treeData[0] = 'home'
//       const matchingItem = locationList[2]
//         ? [...treeData, ...(treeData[0].children as StateDataNode[])].find(
//           (v) => v.path === '/' + locationList[2]
//         )
//         : treeData[0];
//
//       if (matchingItem) {
//         setExpandedKeys((prevExpandedKeys) =>
//           prevExpandedKeys.includes(matchingItem.key as string)
//             ? [...prevExpandedKeys]
//             : [...prevExpandedKeys, matchingItem.key as string]
//         );
//
//         setSelectedKeys((prevSelectedKeys) =>
//           prevSelectedKeys[0] === matchingItem.key
//             ? [...prevSelectedKeys]
//             : [matchingItem.key as string]
//         );
//       }
//     }
//   }, [location.pathname, treeData, foldersQuery.data, isOnArchive, isOnModule]);
//
//   useEffect(() => {
//     if (foldersQuery.data) {
//       const archiveChildren = arrToTree(
//         foldersQuery.data,
//         null,
//         focusOptions,
//         currentFolder
//       );
//
//       setTreeData((prevTreeData) => {
//         const nextTreeData = [...prevTreeData];
//         if (nextTreeData[0].children && nextTreeData[0].children[1]) {
//           // archive is second child of home
//           nextTreeData[0].children[1].children = archiveChildren;
//         }
//
//         return nextTreeData;
//       });
//     }
//   }, [foldersQuery.data, modules.data, currentFolder]);
//
//   // OPEN PRIMARY SVF (same as mobile / home / right panel)
//   const openPrimarySVFfile = useCallback(async () => {
//     if (!projectId) {
//       appLog('[LeftSideView] Missing projectId, cannot open primary SVF');
//       return;
//     }
//
//     try {
//       // if (!archiveSettings?.data?.resArchiveSettings?.primary_svf_render_id) {
//       //   message.error('Primary 3D preview is not set up for this project!');
//       //   return;
//       // }
//
//       const meta = await getPrimarySVFRender(Number(projectId));
//
//       if (!meta) {
//         // Check for the null result from the API function
//         message.error('Primary 3D preview is not set up for this project.');
//         return;
//       }
//
//       const loc = await getPrimarySVFRenderLocation(Number(projectId));
//
//       if (!meta?.file_guid || !loc?.urn || !loc?.access_token) {
//         message.error('Primary 3D preview is not set up for this project.');
//         return;
//       }
//
//       //close previous previews
//       setFileToView(undefined);
//
//       setPrimaryPreviewFile({
//         id: meta.file_guid || 0,
//         title: meta.versioned_file_title,
//         folder_id: meta.versioned_file_folder_id,
//         serial_number: meta.file_serial_number,
//         autodesk_object_id: meta.autodesk_object_id,
//         urn: loc.urn,
//         access_token: loc.access_token,
//       } as any);
//     } catch (err) {
//       appLog('[LeftSideView] openPrimarySVFfile error', err);
//     }
//   }, [projectId, setPrimaryPreviewFile]);
//
//   /** Item click handler */
//   const handleSelect: DirectoryTreeProps['onSelect'] = (keys, info) => {
//     // info.node.key is how we know which nav item it is, e.g. 'archive', 'recents', 'primary-svf-viewer'
//     const clickedKey = info.node.key as string;
//
//     // special case: our 3D preview button
//     if (clickedKey === 'primary-svf-viewer') {
//       openPrimarySVFfile();
//       return;
//     }
//
//     let path = '';
//
//     // @ts-ignore-line
//     const nodePath: string | undefined = info.node.path;
//     if (nodePath) {
//       // if nodePath='/', navigate to ''
//       path = nodePath?.length > 1 ? nodePath : '';
//     } else {
//       path = `/archive/${info.node.key}`;
//     }
//
//     // setSelectedKeys is called in location change effect, triggered by history.push
//     history.push(`/projects/${projectId}` + path);
//   };
//
//   interface HandleRightClickProps {
//     // info: {
//     event:
//       | MouseEvent<Element, globalThis.MouseEvent>
//       | TouchEvent<HTMLSpanElement>;
//     node: EventDataNode | StateDataNode;
//     // }
//   }
//   const handleRightClick = ({ node, event }: HandleRightClickProps) => {
//     if (navigationItems.some((item) => item.key === node.key)) {
//       setRightClickFolder(undefined);
//       setRightClickFolderOverlay(undefined);
//     }
//     const found = foldersQuery.data?.find(
//       (folder) => String(folder.id) === node.key
//     );
//
//     setRightClickFolder(found ? { ...found } : undefined);
//     setRightClickFolderOverlay(found ? { ...found } : undefined);
//   };
//
//   /** Toggle `is_favourite` prop, for selected folder */
//   const toggleFavourite = async () => {
//     if (!rightClickFolder) return;
//     setTimeout(() => toggleFavouriteFolder(rightClickFolder), 100);
//   };
//
//   const { changeDownloadingActive, changeDownloadingState } = useStore();
//
//   const rightClickAction = (modal: string, option?: number) => {
//     const modalsMap = {
//       share: setShareModal,
//       'folder-edit': setFolderEditModal,
//       'folder-move': setFolderMoveModal,
//       'folder-properties': setFolderPropertiesModal,
//       'rights-managment': setFolderRightsModal,
//       'item-log': setItemLogModal,
//       delete: setDeleteModal,
//     };
//
//     // set modal visible
//     if (modalsMap[modal]) {
//       modalsMap[modal](true);
//     } else {
//       // non-modal actions
//       if (modal === 'folder-download') {
//         if (!rightClickFolder) return;
//
//         // activate download progress panel
//         changeDownloadingActive(true);
//         changeDownloadingState(DownloadingState.PREPARING);
//
//         // const hidePrepMsg = message.loading(
//         //   intl.formatMessage({ id: 'download-preparing' }),
//         //   0
//         // );
//         return downloadFolder({
//           folder: rightClickFolder,
//           allFolders: foldersQuery.data || [],
//           fileVersionsContext,
//           onDownloadStarted: () => {
//             // hidePrepMsg();
//             setTimeout(
//               () =>
//                 message.info(intl.formatMessage({ id: 'download-starting' })),
//               400
//             );
//           },
//           onLargeFiles: (largeFiles) => setLargeFilesContext(largeFiles),
//         }).catch((err) => {
//           appLog('downloadFolder -> err', err);
//           // hidePrepMsg && hidePrepMsg();
//           message.error(intl.formatMessage({ id: 'file-download-failed' }));
//         });
//       }
//
//       if (modal === 'favourite') {
//         toggleFavourite();
//       }
//       if (modal === 'folder-focus') {
//         if (!rightClickFolder || !option) return;
//         toggleFocusFolder(rightClickFolder, option);
//       }
//     }
//   };
//
//   const timeOutRef = useRef<number>();
//   const LONG_PRESS_TIME = 6 * 100;
//
//   return (
//     <Fragment>
//       <div
//         css={styles.container}
//         onContextMenu={(e) => e.preventDefault()}
//         onTouchStart={(e) => e.preventDefault()}>
//         <RightClickOverlay
//           focusOptions={focusOptions}
//           leftSide={true}
//           permissionLevel={rightClickFolder?.permission || 0}
//           items={
//             rightClickFolder
//               ? window.sessionStorage.getItem('appState') === 'timeMachine'
//                 ? dataContextMenu.folder.filter(
//                   (item) => item.name === 'download'
//                 )
//                 : dataContextMenu.folder
//               : []
//           }
//           onItemClick={(item, option) => {
//             rightClickAction(item.modal, option);
//             setTimeout(() => setRightClickFolderOverlay(undefined), 1000);
//           }}
//           onOverlayClose={() => {
//             if (rightClickFolder)
//               setTimeout(() => setRightClickFolderOverlay(undefined), 1000);
//           }}
//           selected={{ folder: rightClickFolder }}
//           disabled={!rightClickFolder}>
//           <DirectoryTree
//             className={
//               window.sessionStorage.getItem('appState') !== 'timeMachine'
//                 ? 'draggable-tree'
//                 : 'timeMachine-tree'
//             }
//             blockNode
//             // onContextMenu={handleRightClick}
//             treeData={treeData}
//             selectedKeys={selectedKeys}
//             expandedKeys={expandedKeys}
//             onSelect={handleSelect}
//             onExpand={(keys) => setExpandedKeys(keys as string[])}
//             onRightClick={({ event, node }) =>
//               handleRightClick({ event, node })
//             }
//             css={{
//               width: ['30vw', 'max-content'],
//               minWidth: [
//                 `${TREE_MIN_WIDTH - 10}px`,
//                 `max(${TREE_MIN_WIDTH - 10}px, 18.9vw)`,
//               ],
//             }}
//             onActiveChange={(key) => {
//               appLog('key here -> ', key);
//             }}
//             titleRender={(node: StateDataNode) => (
//               <span
//                 onTouchStart={(event) => {
//                   event.preventDefault();
//                   timeOutRef.current = window.setTimeout(() => {
//                     timeOutRef.current = undefined;
//                     handleRightClick({ event, node });
//                   }, LONG_PRESS_TIME);
//                 }}
//                 onTouchEnd={(e) => {
//                   window.clearTimeout(timeOutRef.current);
//                 }}>
//                 {node.title}
//                 {node.favourite && (
//                   <IconButton
//                     customStyle={{ fontSize: 12, marginBottom: 1 }}
//                     containerStyle={{ minHeight: 20, minWidth: 20 }}
//                     icon={['fas', 'star']}
//                     color="yellow"
//                     backgroundOff
//                   />
//                 )}
//               </span>
//             )}
//           />
//         </RightClickOverlay>
//       </div>
//
//       {/* all modals */}
//       <ShareModal state={shareModal} clicked={() => setShareModal(false)} />
//       <DeleteModal
//         visible={deleteModal}
//         folders={rightClickFolder ? [rightClickFolder] : undefined}
//         onCancel={() => setDeleteModal(false)}
//       />
//       <EditFolderModal
//         visible={folderEditModal}
//         folder={rightClickFolder}
//         onCancel={() => setFolderEditModal(false)}
//       />
//       <MoveModal
//         visible={folderMoveModal}
//         folders={rightClickFolder ? [rightClickFolder] : undefined}
//         folderId={rightClickFolder?.parent_id || null}
//         onCancel={() => setFolderMoveModal(false)}
//       />
//       <RightsModal
//         visible={folderRightsModal}
//         onCancel={() => setFolderRightsModal(false)}
//         folder={rightClickFolder}
//       />
//       <FolderPropertiesModal
//         visible={folderPropertiesModal}
//         onCancel={() => setFolderPropertiesModal(false)}
//         folder={rightClickFolder}
//       />
//       <ItemLogModal
//         visible={itemLogModal}
//         onCancel={() => {
//           setItemLogModal(false);
//           setRightClickFolderOverlay(undefined);
//         }}
//         folder={rightClickFolder}
//       />
//     </Fragment>
//   );
// };
//
// export default LeftSideView;
//
// const styleFn: ThemedStyleFn = (theme) => ({
//   container: {
//     height: '100%',
//     maxHeight: '100%',
//     width: '100%',
//     padding: 5,
//     overflow: 'auto',
//   },
//   icons: {
//     fontSize: '20px',
//     transition: '0.3s',
//     margin: '3px 0 10px -16px',
//   },
//   badge: {
//     right: '-4px',
//     bottom: '14px',
//   },
//   grayBlue: {
//     color: '#184a9a',
//   },
//   iconRed: {
//     color: theme.colors.red,
//   },
// });
//
// const FolderIcon = (props) => {
//   const styles = useStyles(styleFn);
//   const { is_empty, state } = props;
//
//   return (
//     <IconButton
//       iconStyle="fas"
//       customStyle={styles.icons}
//       icon={'folder'}
//       iconSecond={state === DB_STATE.DELETED ? ['fad', 'trash'] : null}
//       colorSecondIcon={'red'}
//       customStyleSecondIcon={{ right: '-3px', top: '12px' }}
//       color={'yellow'}
//       backgroundOff
//       badge={state !== DB_STATE.DELETED && is_empty && '0'}
//       badgeStyle={styles.badge}
//       {...props}
//     />
//   );
// };
//
// const dbFolderToTreeObj = (dbFolder: DbFolder): StateDataNode => {
//   const { id, name, parent_id, is_empty, is_favorite, state } = dbFolder;
//
//   return {
//     title: name || 'Unknown',
//     key: String(id),
//     icon: <FolderIcon is_empty={is_empty} state={state} />,
//     children: [],
//     parentId: String(parent_id),
//     favourite: is_favorite,
//   };
// };
//
// // TODO: look into efficiency improvements
// /**
//  * transforms db folder list in directory tree
//  */
//
// const getBackgroundComponent = (
//   focusOptions?: DbFocusOptions[],
//   dbFolder?: DbFolder,
//   currentFolder?: DbFolder
// ) => {
//   const data =
//     dbFolder && dbFolder.focus
//       ? _.find(focusOptions, {
//         value: dbFolder.focus,
//       })
//       : '';
//
//   if (dbFolder?.id === currentFolder?.id && data) {
//     return {
//       color: 'black',
//
//       background: `${data ? '#' + data.color_hex_code_opacity : ''}`,
//     };
//   }
//   return {
//     color: 'black',
//     background: `${data ? '#' + data.color_hex_code : ''}`,
//   };
// };
//
// const getSelectedClassNameNum = (
//   dbFolder?: DbFolder,
//   currentFolder?: DbFolder
// ) => {
//   if (dbFolder?.id === currentFolder?.id) {
//     return dbFolder?.focus;
//   }
// };
// export const arrToTree = (
//   arr: DbFolder[],
//   parentId: DbFolder['parent_id'],
//   focusOptions?: DbFocusOptions[],
//   currentFolder?: DbFolder
// ): StateDataNode[] => {
//   return arr
//     .filter((dbFolder) => dbFolder.parent_id === parentId)
//     .map((dbFolder) => ({
//       ...dbFolderToTreeObj(dbFolder),
//       children: arrToTree(arr, dbFolder.id, focusOptions, currentFolder),
//       createdAt: dbFolder.created_at,
//       description: dbFolder.description,
//       name: dbFolder.name,
//       className: `ant-table-row-selected${getSelectedClassNameNum(
//         dbFolder,
//         currentFolder
//       )}`,
//       style: getBackgroundComponent(focusOptions, dbFolder, currentFolder),
//     }));
// };

// /** @jsxRuntime classic */
// /** @jsx jsx */
// import { jsx } from '@emotion/core';
// import {
//   useState,
//   useEffect,
//   useRef,
//   Fragment,
//   useContext,
//   MouseEvent,
//   TouchEvent,
// } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
// import { Tree, Modal, message, ConfigProvider } from 'antd';
// import { useIntl } from 'react-intl';
// import { IconProp } from '@fortawesome/fontawesome-svg-core';
// import { DataNode, DirectoryTreeProps, EventDataNode } from 'antd/lib/tree';
//
// import IconButton from '~components/_common/IconButton/IconButton';
// import navigationItems, {
//   navigationItemsTimeMachine,
// } from '~src/data/navigationItems';
// import { getParentsIds } from '~src/utils/tree';
// import { DbFolder, DbFocusOptions } from '~src/types/db';
// import { TREE_MIN_WIDTH } from '~src/config';
// import { useFolders } from '~src/hooks/api-hooks/useFolders';
// import { useProject } from '~src/hooks/api-hooks/useProject';
//
// import dataContextMenu from '~src/data/dataContextMenu';
// import ShareModal from '~components/popups-modals/ShareModal/ShareModal';
// import { FolderPropertiesModal } from '~components/popups-modals/FolderPropertiesModal/FolderPropertiesModal';
// import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
// import { EditFolderModal } from '~components/popups-modals/EditFolder.modal';
// import { MoveModal } from '~components/popups-modals/Move.modal';
// import { DeleteModal } from '~components/popups-modals/Delete.modal';
// import { NavIcon } from '~components/_common/NavIcon/NavIcon';
// import { downloadFolder } from '~src/utils/download';
// import { appLog } from '~src/utils/log';
// import LargeFilesContext from '~src/contexts/LargeFilesContext';
// import FileVersionsContext from '~src/contexts/FileVersionsContext';
// import { RightsModal } from '~components/popups-modals/RightsModal/RightsModal';
// import { useToggleFavouriteFolder } from '~src/hooks/actions/useToggleFavouriteFolder';
// import { RightClickOverlay } from '~components/atoms/RightClickOverlay/RightClickOverlay';
// import { useItemPermission } from '~src/hooks/useItemPermission';
// import { useProjectId } from '~src/hooks/useProjectId';
//
// import { useIsPath } from '~src/hooks/useIsPath';
//
// import { DB_STATE, MODULES } from '~src/types/enums';
// import ProjectSrc from '~src/assets/nav-icons/project.png';
// import { useModules } from '~src/hooks/api-hooks/useModules';
// import { ItemLogModal } from '~components/popups-modals/ItemLog.modal';
// import _ from 'lodash';
// import { useToggleFocusFolder } from '~src/hooks/actions/useToggleFocusFolder';
// import { focusOptions } from '~components/atoms/RightClickOverlay/data';
// import { useCurrentFolder } from '~src/hooks/useCurrentFolder';
// import { useArchiveSettings } from '~src/hooks/api-hooks/useArchiveSettings';
// import { DownloadingState, useStore } from '~src/store';
//
// const { DirectoryTree } = Tree;
//
// type StateDataNode = DataNode & {
//   path?: string;
//   children?: StateDataNode[];
//   parentId?: string | null;
//   favourite?: boolean;
//   moduleId?: MODULES;
// };
//
// const LeftSideView: React.FC = () => {
//   // hooks
//   const styles = useStyles(styleFn);
//   const intl = useIntl();
//   const history = useHistory();
//   const location = useLocation();
//   const projectId = useProjectId();
//   const currentFolder = useCurrentFolder();
//
//   const foldersQuery = useFolders({
//     before:
//       window.sessionStorage.getItem('timeMachineDate') !== null
//         ? Number(window.sessionStorage.getItem('timeMachineDate'))
//         : undefined,
//     as_admin:
//       window.sessionStorage.getItem('appState') === 'superUser'
//         ? true
//         : undefined,
//   });
//   const projectQuery = useProject();
//   const isOnArchive = useIsPath('/archive');
//   const isOnModule = useIsPath('/module');
//   const modules = useModules();
//   const archiveSettings = useArchiveSettings();
//
//   const { setLargeFilesContext } = useContext(LargeFilesContext);
//   const { fileVersionsContext } = useContext(FileVersionsContext);
//
//   const { toggleFavouriteFolder } = useToggleFavouriteFolder();
//   const { toggleFocusFolder } = useToggleFocusFolder();
//
//   // state for all modals
//   const [shareModal, setShareModal] = useState(false);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [folderEditModal, setFolderEditModal] = useState(false);
//   const [folderMoveModal, setFolderMoveModal] = useState(false);
//   const [folderPropertiesModal, setFolderPropertiesModal] = useState(false);
//   const [folderRightsModal, setFolderRightsModal] = useState(false);
//   const [itemLogModal, setItemLogModal] = useState(false);
//
//   const [rightClickFolder, setRightClickFolder] = useState<DbFolder>();
//   const [
//     rightClickFolderOverlay,
//     setRightClickFolderOverlay,
//   ] = useState<DbFolder>();
//
//   const rightClickFolderParentPermission = useItemPermission({
//     folder: rightClickFolderOverlay,
//   });
//
//   const errorModalRef = useRef<ReturnType<typeof Modal.error>>();
//
//   // states
//   const [treeData, setTreeData] = useState<StateDataNode[]>([
//     {
//       title: '',
//       path: '/',
//       key: 'home',
//       icon: <NavIcon icon={ProjectSrc} />,
//       parentId: null,
//       children: [],
//     },
//   ]);
//
//   const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
//   const [expandedKeys, setExpandedKeys] = useState<string[]>(['home']);
//
//   // effects
//   useEffect(() => {
//     if (modules.data) {
//       setTreeData((prevState) => {
//         const nextState = [...prevState];
//         nextState[0].children = [
//           ...(window.sessionStorage.getItem('appState') === 'timeMachine'
//             ? navigationItemsTimeMachine
//             : navigationItems),
//         ]
//           .filter(
//             (v) =>
//               (v.section !== 'special' ||
//                 (modules.data &&
//                   v?.moduleName &&
//                   modules.data[v.moduleName])) &&
//               v.key !== 'shared-with-me'
//           )
//           .map((navItem) => ({
//             title: intl.formatMessage({ id: navItem.nameTerm }),
//             path: navItem.path,
//             key: navItem.key,
//             moduleId: navItem.id,
//             icon:
//               navItem.section === 'project-data' ? (
//                 <IconButton
//                   icon={navItem.icon as IconProp}
//                   color={navItem.color}
//                   customStyle={styles.icons}
//                   backgroundOff
//                 />
//               ) : (
//                 <NavIcon icon={navItem.customIcon as string} />
//               ),
//             parentId: null,
//           }));
//         return [...nextState];
//       });
//     }
//   }, [modules.data]);
//
//   useEffect(() => {
//     if (foldersQuery.error) {
//       const modalContent =
//         intl.formatMessage({ id: 'load-folders-error' }) +
//         (foldersQuery.error.code ? ` (${foldersQuery.error.code})` : '');
//
//       if (!errorModalRef.current) {
//         errorModalRef.current = Modal.error({
//           title: intl.formatMessage({ id: 'generic-error' }),
//           content: modalContent,
//           keyboard: false, // disable close on ESC
//           okButtonProps: { loading: foldersQuery.isLoading },
//           okText: intl.formatMessage({ id: 'try-again' }),
//           onOk: () => foldersQuery.refetch({ throwOnError: true }),
//         });
//       } else {
//         errorModalRef.current.update({
//           content: modalContent,
//           okButtonProps: { loading: foldersQuery.isLoading },
//         });
//       }
//     } else if (errorModalRef.current) {
//       errorModalRef.current.destroy();
//       errorModalRef.current = undefined;
//     }
//   }, [foldersQuery, intl]);
//
//   useEffect(() => {
//     if (projectQuery.data) {
//       setTreeData((prevState) => {
//         const nextState = [...prevState];
//         nextState[0].title =
//           projectQuery.data?.name || intl.formatMessage({ id: 'home' });
//         return nextState;
//       });
//     }
//   }, [projectQuery.data]);
//
//   /** set selected item based on location */
//   useEffect(() => {
//     const locationList = location.pathname.split('/').filter(Boolean);
//
//     // if folder location
//     if (locationList.length > 3 && foldersQuery.data) {
//       if (isOnArchive) {
//         const folderId = locationList[3];
//
//         setExpandedKeys((prevExpandedKeys) => {
//           if (prevExpandedKeys.includes(folderId)) {
//             return [...prevExpandedKeys];
//           }
//
//           const parents = getParentsIds(foldersQuery.data || [], folderId);
//
//           return [...prevExpandedKeys, 'archive', ...parents, folderId];
//         });
//
//         setSelectedKeys((prevSelectedKeys) =>
//           prevSelectedKeys[0] === folderId ? [...prevSelectedKeys] : [folderId]
//         );
//
//         return;
//       }
//
//       if (isOnModule) {
//         const moduleId = locationList[3];
//         const matchingItemIndex = (treeData[0]
//           .children as StateDataNode[]).findIndex(
//           (item) => Number(moduleId) === item?.moduleId
//         );
//         const matchingItem = (treeData[0].children as StateDataNode[])[
//           matchingItemIndex
//         ];
//         if (matchingItem) {
//           setExpandedKeys((prevExpandedKeys) =>
//             prevExpandedKeys.includes(matchingItem.key as string)
//               ? [...prevExpandedKeys]
//               : [...prevExpandedKeys, matchingItem.key as string]
//           );
//
//           setSelectedKeys((prevSelectedKeys) =>
//             prevSelectedKeys[0] && prevSelectedKeys[0] === matchingItem.key
//               ? [...prevSelectedKeys]
//               : [matchingItem.key as string]
//           );
//         }
//         return;
//       }
//     }
//
//     if (locationList.length > 1) {
//       // if level 1 location e.g. archive, recent etc.
//       // if no lv1 location, match treeData[0] = 'home'
//       const matchingItem = locationList[2]
//         ? [...treeData, ...(treeData[0].children as StateDataNode[])].find(
//             (v) => v.path === '/' + locationList[2]
//           )
//         : treeData[0];
//
//       if (matchingItem) {
//         setExpandedKeys((prevExpandedKeys) =>
//           prevExpandedKeys.includes(matchingItem.key as string)
//             ? [...prevExpandedKeys]
//             : [...prevExpandedKeys, matchingItem.key as string]
//         );
//
//         setSelectedKeys((prevSelectedKeys) =>
//           prevSelectedKeys[0] === matchingItem.key
//             ? [...prevSelectedKeys]
//             : [matchingItem.key as string]
//         );
//       }
//     }
//   }, [location.pathname, treeData, foldersQuery.data, isOnArchive, isOnModule]);
//
//   useEffect(() => {
//     if (foldersQuery.data) {
//       const archiveChildren = arrToTree(
//         foldersQuery.data,
//         null,
//         focusOptions,
//         currentFolder
//       );
//
//       setTreeData((prevTreeData) => {
//         const nextTreeData = [...prevTreeData];
//         if (nextTreeData[0].children && nextTreeData[0].children[0]) {
//           // archive is first child of home
//           nextTreeData[0].children[0].children = archiveChildren;
//         }
//
//         return nextTreeData;
//       });
//     }
//   }, [foldersQuery.data, modules.data, currentFolder]);
//
//   /** Item click handler */
//   const handleSelect: DirectoryTreeProps['onSelect'] = (keys, info) => {
//     let path = '';
//
//     // @ts-ignore-line
//     const nodePath: string | undefined = info.node.path;
//     if (nodePath) {
//       // if nodePath='/', navigate to ''
//       path = nodePath?.length > 1 ? nodePath : '';
//     } else {
//       path = `/archive/${info.node.key}`;
//     }
//
//     // setSelectedKeys is called in location change effect, triggered by history.push
//     history.push(`/projects/${projectId}` + path);
//   };
//
//   interface HandleRightClickProps {
//     // info: {
//     event:
//       | MouseEvent<Element, globalThis.MouseEvent>
//       | TouchEvent<HTMLSpanElement>;
//     node: EventDataNode | StateDataNode;
//     // }
//   }
//   const handleRightClick = ({ node, event }: HandleRightClickProps) => {
//     if (navigationItems.some((item) => item.key === node.key)) {
//       setRightClickFolder(undefined);
//       setRightClickFolderOverlay(undefined);
//     }
//     const found = foldersQuery.data?.find(
//       (folder) => String(folder.id) === node.key
//     );
//
//     setRightClickFolder(found ? { ...found } : undefined);
//     setRightClickFolderOverlay(found ? { ...found } : undefined);
//   };
//
//   /** Toggle `is_favourite` prop, for selected folder */
//   const toggleFavourite = async () => {
//     if (!rightClickFolder) return;
//     setTimeout(() => toggleFavouriteFolder(rightClickFolder), 100);
//   };
//
//   const { changeDownloadingActive, changeDownloadingState } = useStore();
//
//   const rightClickAction = (modal: string, option?: number) => {
//     const modalsMap = {
//       share: setShareModal,
//       'folder-edit': setFolderEditModal,
//       'folder-move': setFolderMoveModal,
//       'folder-properties': setFolderPropertiesModal,
//       'rights-managment': setFolderRightsModal,
//       'item-log': setItemLogModal,
//       delete: setDeleteModal,
//     };
//
//     // set modal visible
//     if (modalsMap[modal]) {
//       modalsMap[modal](true);
//     } else {
//       // non-modal actions
//       if (modal === 'folder-download') {
//         if (!rightClickFolder) return;
//
//         // activate download progress panel
//         changeDownloadingActive(true);
//         changeDownloadingState(DownloadingState.PREPARING);
//
//         // const hidePrepMsg = message.loading(
//         //   intl.formatMessage({ id: 'download-preparing' }),
//         //   0
//         // );
//         return downloadFolder({
//           folder: rightClickFolder,
//           allFolders: foldersQuery.data || [],
//           fileVersionsContext,
//           onDownloadStarted: () => {
//             // hidePrepMsg();
//             setTimeout(
//               () =>
//                 message.info(intl.formatMessage({ id: 'download-starting' })),
//               400
//             );
//           },
//           onLargeFiles: (largeFiles) => setLargeFilesContext(largeFiles),
//         }).catch((err) => {
//           appLog('downloadFolder -> err', err);
//           // hidePrepMsg && hidePrepMsg();
//           message.error(intl.formatMessage({ id: 'file-download-failed' }));
//         });
//       }
//
//       if (modal === 'favourite') {
//         toggleFavourite();
//       }
//       if (modal === 'folder-focus') {
//         if (!rightClickFolder || !option) return;
//         toggleFocusFolder(rightClickFolder, option);
//       }
//     }
//   };
//
//   const timeOutRef = useRef<number>();
//   const LONG_PRESS_TIME = 6 * 100;
//
//   return (
//     <Fragment>
//       <div
//         css={styles.container}
//         onContextMenu={(e) => e.preventDefault()}
//         onTouchStart={(e) => e.preventDefault()}>
//         <RightClickOverlay
//           focusOptions={focusOptions}
//           leftSide={true}
//           permissionLevel={rightClickFolder?.permission || 0}
//           items={
//             rightClickFolder
//               ? window.sessionStorage.getItem('appState') === 'timeMachine'
//                 ? dataContextMenu.folder.filter(
//                     (item) => item.name === 'download'
//                   )
//                 : dataContextMenu.folder
//               : []
//           }
//           onItemClick={(item, option) => {
//             rightClickAction(item.modal, option);
//             setTimeout(() => setRightClickFolderOverlay(undefined), 1000);
//           }}
//           onOverlayClose={() => {
//             if (rightClickFolder)
//               setTimeout(() => setRightClickFolderOverlay(undefined), 1000);
//           }}
//           selected={{ folder: rightClickFolder }}
//           disabled={!rightClickFolder}>
//           <DirectoryTree
//             className={
//               window.sessionStorage.getItem('appState') !== 'timeMachine'
//                 ? 'draggable-tree'
//                 : 'timeMachine-tree'
//             }
//             blockNode
//             // onContextMenu={handleRightClick}
//             treeData={treeData}
//             selectedKeys={selectedKeys}
//             expandedKeys={expandedKeys}
//             onSelect={handleSelect}
//             onExpand={(keys) => setExpandedKeys(keys as string[])}
//             onRightClick={({ event, node }) =>
//               handleRightClick({ event, node })
//             }
//             css={{
//               width: ['30vw', 'max-content'],
//               minWidth: [
//                 `${TREE_MIN_WIDTH - 10}px`,
//                 `max(${TREE_MIN_WIDTH - 10}px, 18.9vw)`,
//               ],
//             }}
//             onActiveChange={(key) => {
//               appLog('key here -> ', key);
//             }}
//             titleRender={(node: StateDataNode) => (
//               <span
//                 onTouchStart={(event) => {
//                   event.preventDefault();
//                   timeOutRef.current = window.setTimeout(() => {
//                     timeOutRef.current = undefined;
//                     handleRightClick({ event, node });
//                   }, LONG_PRESS_TIME);
//                 }}
//                 onTouchEnd={(e) => {
//                   window.clearTimeout(timeOutRef.current);
//                 }}>
//                 {node.title}
//                 {node.favourite && (
//                   <IconButton
//                     customStyle={{ fontSize: 12, marginBottom: 1 }}
//                     containerStyle={{ minHeight: 20, minWidth: 20 }}
//                     icon={['fas', 'star']}
//                     color="yellow"
//                     backgroundOff
//                   />
//                 )}
//               </span>
//             )}
//           />
//         </RightClickOverlay>
//       </div>
//
//       {/* all modals */}
//       <ShareModal state={shareModal} clicked={() => setShareModal(false)} />
//       <DeleteModal
//         visible={deleteModal}
//         folders={rightClickFolder ? [rightClickFolder] : undefined}
//         onCancel={() => setDeleteModal(false)}
//       />
//       <EditFolderModal
//         visible={folderEditModal}
//         folder={rightClickFolder}
//         onCancel={() => setFolderEditModal(false)}
//       />
//       <MoveModal
//         visible={folderMoveModal}
//         folders={rightClickFolder ? [rightClickFolder] : undefined}
//         folderId={rightClickFolder?.parent_id || null}
//         onCancel={() => setFolderMoveModal(false)}
//       />
//       <RightsModal
//         visible={folderRightsModal}
//         onCancel={() => setFolderRightsModal(false)}
//         folder={rightClickFolder}
//       />
//       <FolderPropertiesModal
//         visible={folderPropertiesModal}
//         onCancel={() => setFolderPropertiesModal(false)}
//         folder={rightClickFolder}
//       />
//       <ItemLogModal
//         visible={itemLogModal}
//         onCancel={() => {
//           setItemLogModal(false);
//           setRightClickFolderOverlay(undefined);
//         }}
//         folder={rightClickFolder}
//       />
//     </Fragment>
//   );
// };
//
// export default LeftSideView;
//
// const styleFn: ThemedStyleFn = (theme) => ({
//   container: {
//     height: '100%',
//     maxHeight: '100%',
//     width: '100%',
//     padding: 5,
//     overflow: 'auto',
//   },
//   icons: {
//     fontSize: '20px',
//     transition: '0.3s',
//     margin: '3px 0 10px -16px',
//   },
//   badge: {
//     right: '-4px',
//     bottom: '14px',
//   },
// });
//
// const FolderIcon = (props) => {
//   const styles = useStyles(styleFn);
//   const { is_empty, state } = props;
//
//   return (
//     <IconButton
//       iconStyle="fas"
//       customStyle={styles.icons}
//       icon={'folder'}
//       iconSecond={state === DB_STATE.DELETED ? ['fad', 'trash'] : null}
//       colorSecondIcon={'red'}
//       customStyleSecondIcon={{ right: '-3px', top: '12px' }}
//       color={'yellow'}
//       backgroundOff
//       badge={state !== DB_STATE.DELETED && is_empty && '0'}
//       badgeStyle={styles.badge}
//       {...props}
//     />
//   );
// };
//
// const dbFolderToTreeObj = (dbFolder: DbFolder): StateDataNode => {
//   const { id, name, parent_id, is_empty, is_favorite, state } = dbFolder;
//
//   return {
//     title: name || 'Unknown',
//     key: String(id),
//     icon: <FolderIcon is_empty={is_empty} state={state} />,
//     children: [],
//     parentId: String(parent_id),
//     favourite: is_favorite,
//   };
// };
//
// // TODO: look into efficiency improvements
// /**
//  * transforms db folder list in directory tree
//  */
//
// const getBackgroundComponent = (
//   focusOptions?: DbFocusOptions[],
//   dbFolder?: DbFolder,
//   currentFolder?: DbFolder
// ) => {
//   const data =
//     dbFolder && dbFolder.focus
//       ? _.find(focusOptions, {
//           value: dbFolder.focus,
//         })
//       : '';
//
//   if (dbFolder?.id === currentFolder?.id && data) {
//     return {
//       color: 'black',
//
//       background: `${data ? '#' + data.color_hex_code_opacity : ''}`,
//     };
//   }
//   return {
//     color: 'black',
//     background: `${data ? '#' + data.color_hex_code : ''}`,
//   };
// };
//
// const getSelectedClassNameNum = (
//   dbFolder?: DbFolder,
//   currentFolder?: DbFolder
// ) => {
//   if (dbFolder?.id === currentFolder?.id) {
//     return dbFolder?.focus;
//   }
// };
// export const arrToTree = (
//   arr: DbFolder[],
//   parentId: DbFolder['parent_id'],
//   focusOptions?: DbFocusOptions[],
//   currentFolder?: DbFolder
// ): StateDataNode[] => {
//   return arr
//     .filter((dbFolder) => dbFolder.parent_id === parentId)
//     .map((dbFolder) => ({
//       ...dbFolderToTreeObj(dbFolder),
//       children: arrToTree(arr, dbFolder.id, focusOptions, currentFolder),
//       createdAt: dbFolder.created_at,
//       description: dbFolder.description,
//       name: dbFolder.name,
//       className: `ant-table-row-selected${getSelectedClassNameNum(
//         dbFolder,
//         currentFolder
//       )}`,
//       style: getBackgroundComponent(focusOptions, dbFolder, currentFolder),
//     }));
// };

/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { DataNode } from 'antd/lib/tree';
import { useIsPath } from '~src/hooks/useIsPath';
import { MODULES } from '~src/types/enums';
import HomeLeftSideView from './views/HomeLeftSideView';
import ProjectLeftSideView from './views/ProjectLeftSideView';

export type StateDataNode<MetaT = unknown> = DataNode & {
  path?: string;
  children?: StateDataNode<MetaT>[];
  parentId?: string | null;
  favourite?: boolean;
  moduleId?: MODULES;
  isTender?: boolean;
  keyPath?: string | null;
  type?: string | null;
  isTenderRootFolder?: string | null;
  tenderRegistrationId?: string | null;
  firstElementId?: string;
  isUnassigned?: boolean;
  meta?: MetaT;
};

const LeftSideView: React.FC<Record<string, unknown>> = () => {
  const isProjectDetailsPage = useIsPath('/projects');

  if (isProjectDetailsPage) return <ProjectLeftSideView />;

  return <HomeLeftSideView />;
};

export default LeftSideView;
